import styled from 'styled-components';

export const StyledSignUp = styled.div`
  padding: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: var(--color-white);
  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.15);
  border-radius: 12px;
  overflow: hidden;
  min-width: 410px;
  min-height: 387px;

  .su-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: none;
    padding: 32px 36px 0;

    &-left {
      font-weight: 600;
      font-size: 22px;
      line-height: 33px;
    }

    &-right {
      &-up {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 12px;

        > img {
          width: 52px;
          height: 29px;
          object-fit: contain;
        }
      }

      &-down {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;

        p {
          width: 20px;
          height: 20px;
          font-weight: 500;
          font-size: 11px;
          line-height: 20.5px;
          letter-spacing: 0%;
          text-align: center;
          color: var(--color-white);
          background-color: var(--color-light-gray);
          border-radius: 50%;
          cursor: pointer;
          transition: all 0.3s ease-in-out;

          &.active {
            color: var(--color-white);
            background-color: var(--color-primary-blue);
          }
        }
      }
    }
  }

  .su-body {
    padding: 12px 36px 0;
    max-height: 60vh;
    overflow-y: auto;
  }

  .su-footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 20px;
    padding: 20px 36px 36px;

    > button {
      width: auto !important;
      text-transform: capitalize;

      &.prev {
        color: var(--color-medium-gray);
        background: var(--color-light-gray);
      }
    }
  }
`;
